import script from "./ExecutiveInscriptionAttachments.vue?vue&type=script&setup=true&lang=js"
export * from "./ExecutiveInscriptionAttachments.vue?vue&type=script&setup=true&lang=js"

import "./ExecutiveInscriptionAttachments.vue?vue&type=style&index=0&id=012c6f49&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-012c6f49"]])

export default __exports__